(()=>{
  // Guard: run only when header/nav exists
  window.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('#header');
    if (!header) return;

    const nav = header.querySelector('#nav');
    if (!nav) return;

    const gnb = nav.querySelector('.gnb');
    if (!gnb) return;


    const clearInactiveAll = () => {
      gnb.querySelectorAll(':scope > li.--inactive').forEach((li) => li.classList.remove('--inactive'));
    };

    const updateGnbCursor = () => {
      const activeMenu = gnb.querySelector('li.--active');
      if (!activeMenu) {
        nav.style.setProperty('--gnb-cursor-width', 0);
        return;
      }
      const activeMenuRect = activeMenu.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();
      const gnbCursorWidth = activeMenuRect.width;
      nav.style.setProperty('--gnb-cursor-width', `${gnbCursorWidth}px`);
      const gnbCursorLeft = activeMenuRect.left - headerRect.left;
      nav.style.setProperty('--gnb-cursor-left', `${gnbCursorLeft}px`);
    }

    window.addEventListener('resize', () => {
      requestAnimationFrame(()=>{
        updateGnbCursor();
      });
    })

    const onEnter = (li) => {
      header.classList.add('--force-show');
      gnb.classList.add('--hover');
      li.classList.add('--active');
      const megamenu = li.querySelector('.megamenu');
      updateGnbCursor();
      if (megamenu) {
        megamenu.classList.remove('--inactive');
        megamenu.classList.add('--active');
        const megamenuHeight = megamenu.clientHeight;
        header.style.setProperty('--bg-height', `${header.clientHeight + megamenuHeight}px`);
      }
    };

    const onLeave = (li) => {
      const megamenu = li.querySelector('.megamenu');
      gnb.classList.remove('--hover');
      li.classList.remove('--active');
      nav.style.setProperty('--gnb-cursor-width', 0);
      if (megamenu) {
        megamenu.classList.remove('--active');
        clearInactiveAll();
      }
      header.style.removeProperty('--bg-height');
      // If pointer leaves a single li, only clear when gnb has no other active li or hover
      // Rely on mouseleave of gnb and blur on nav to fully reset
    };

    // Use focus/blur with capture to work even when focus is on <a> inside <li>
    gnb.querySelectorAll(':scope > li').forEach((li) => {
      li.addEventListener('mouseenter', () => onEnter(li));
      li.addEventListener('mouseleave', () => {
        onLeave(li);
        // If the mouse left this li and is not over any other li, clear inactive
        const isOverAnother = [...gnb.querySelectorAll(':scope > li')].some((x) => x.matches(':hover'));
        if (!isOverAnother) {
          clearInactiveAll();
        }
      });

      li.addEventListener('focus', () => onEnter(li), true);
      li.addEventListener(
          'blur',
          (e) => {
            if (!li.contains(e.relatedTarget)) {
              onLeave(li);
              // If focus moved outside gnb or to a non-sibling, clear
              if (!gnb.contains(e.relatedTarget)) clearInactiveAll();
            }
          },
          true
      );
    });

    // Remove opaque state and reset when leaving the gnb entirely
    gnb.addEventListener('mouseleave', () => {
      header.classList.remove('--force-show');
      clearInactiveAll();
    });

    // Also reset when focus leaves nav area (capture to detect descendant blur)
    nav.addEventListener(
        'blur',
        (e) => {
          if (!nav.contains(e.relatedTarget)) {
            header.classList.remove('--force-show');
            nav.querySelectorAll('.megamenu.--active').forEach((m) => m.classList.remove('--active'));
            clearInactiveAll();
          }
        },
        true
    );

    nav.querySelectorAll('.megamenu .__depth2').forEach((depth2) => {
      depth2.addEventListener('mouseenter', () => {
        depth2.classList.add('--hover');
      })
      depth2.addEventListener('mouseleave', () => {
        depth2.classList.remove('--hover');
      })
      depth2.querySelectorAll(':scope > li').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          item.classList.add('--active');
          const depth3 = item.querySelector('.__depth3');
          if (depth3) {
            const depth2Height = depth2.clientHeight;
            const depth3Height = depth3.clientHeight;
            if (depth2Height < depth3Height) {
              const currentBgHeight = parseInt(getComputedStyle(header).getPropertyValue('--bg-height')) || header.clientHeight;
              header.style.setProperty('--bg-height', `${currentBgHeight + depth3Height - depth2Height}px`);
            }
          }
        });
        item.addEventListener('mouseleave', () => {
          item.classList.remove('--active');
          const megamenu = depth2.closest('.megamenu');
          const megamenuHeight = megamenu.clientHeight;
          header.style.setProperty('--bg-height', `${header.clientHeight + megamenuHeight}px`);
        });
      })
    });

    nav.querySelectorAll('.megamenu .__depth3').forEach((depth3) => {
      depth3.addEventListener('mouseenter', () => {
        depth3.classList.add('--hover');
      })
      depth3.addEventListener('mouseleave', () => {
        depth3.classList.remove('--hover');
      })
      depth3.querySelectorAll(':scope > li').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          item.classList.add('--active');
        });
        item.addEventListener('mouseleave', () => {
          item.classList.remove('--active');
        });
      })
    });

    const isMovileNav = () => {
      const navStyles = getComputedStyle(nav);
      const position = navStyles.getPropertyValue('position');
      return position === 'fixed' || position === 'absolute';
    }

    const btnToggleNav = header.querySelector('.btn-toggle-nav');
    if (btnToggleNav) {
      btnToggleNav.addEventListener('click', () => {
        header.classList.toggle('--nav-opened');
        header.classList.toggle('--force-show');
      });
    }

    gnb.querySelectorAll('.__depth1').forEach((depth1) => {
      depth1.addEventListener('click', e =>{
        if (isMovileNav()) {
          e.preventDefault();
          const li = depth1.closest('li');
          gnb.querySelectorAll('li.--show-depth2').forEach((item) => {
            if (item !== li ) item.classList.remove('--show-depth2');
          })
          li.classList.toggle('--show-depth2');
        }

      });
    })
  });
})();